import { render, staticRenderFns } from "./dropzoneComp.vue?vue&type=template&id=07edd030"
import script from "./dropzoneComp.vue?vue&type=script&lang=js"
export * from "./dropzoneComp.vue?vue&type=script&lang=js"
import style0 from "./dropzoneComp.vue?vue&type=style&index=0&id=07edd030&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
